import { lazy } from 'react';

export { Tariffs } from './tariffs';

export const LazyTariffs = lazy(() => import('./tariffs').then((mod) => ({ default: mod.Tariffs })));
